import { Component, Input, OnInit, ViewChild, HostListener, OnDestroy, ContentChild, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { SessionStorageService } from 'ngx-webstorage';
import { filter } from 'rxjs/operators';
import { Url } from '@ark-libs/ngx-utils';

import { Principal } from '../../services/auth/principal.service';
import { CoreConfigService } from '../../services/config/core-config.service';
import { AppSettingService } from '../../services/service/app-setting.service';
import { UserStorageService } from '../../services/service/user-storage.service';
import { UserContextService } from '../../services/service/user-context.service';
import { SubscriptionManager } from '../../services/service/subscription-mamager';
import { UploadPhotoHelper } from '../../services/helper/upload-photo.helper';
import { AppStateService } from '../../services/service/app-state.service';
import { AppSwitcherService } from '../../services/service/app-switcher.service';
import { ReadyState, ReadyStateFlag } from '../../services/service/ready-state.model';
import { NavMenu } from '../../components/model/nav-menu';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DataDictService } from '../../services/service/data-dict.service';
import { NoticeItem } from '../../components/model/notice-item';
import { UaaResourceService } from '../../services/service/uaa-resource.service';
// import { routeAnimation } from '../animations/route-animation';

@Component({
	selector: 'zx-layout-main',
	templateUrl: './main.component.html',
	styleUrls: ['./main.component.css'],
	// animations: [routeAnimation]  // 加上过场动画后，content区为overflow模式时有问题，暂时停用
})
export class MainComponent implements OnInit, OnDestroy {

	// // router跳转动画所需参数
	// routerState: boolean = true;
	// routerStateCode: string = 'active';

	private defaultLogo = "data:image/png;base64,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";
	private photoBaseUrl;
	private defaultWinTitle;
	private _currentApp;
	private _currentOffice;
	private _navMenu: NavMenu;
	private _navigationStartUrl;
	private _isCollapsed = false;

	forbidden: boolean = false;

	logoIcon: string;
	logoWide: string;
	footerText: string;
	navbarResourceName: string;
	userCenterApp:string;

	layoutCollapsed = false;
	hiddenScrolling: boolean = false;
	hiddenMainLayout: boolean = false;
	hiddenAppletTitle: boolean = false;
	hiddenOfficeTitle: boolean = false;
	hiddenNoticeIcon: boolean = false;
	hiddenSiderMenu: boolean = false;
	hiddenHeaderMenu: boolean = false;
	enableMainContentReplacement: boolean = false;

	loadingMessage: string = null;
	showLoading: boolean = true;
	showLoadingTimer = null;
	showLoadingContent: boolean = false;
	navigateTimer = null;
	loading: boolean;
	count: any;
	_messageKind: any[] = [];
	timeId: any;
	overflowCount: number = 99;
	data: NoticeItem[] = [
		// { title: '通知', list: [], emptyText: '你已查看所有通知', emptyImage: 'https://gw.alipayobjects.com/zos/rmsportal/wAhyIChODzsoKIOBHcBk.svg' },
		{ title: '消息', list: [], emptyText: '您已读完所有消息', emptyImage: 'assets/images/message.svg' },
	];
	navShowType: string;
	baseRouteUrl: string;

    @ContentChild('afterAppletSelector', {static:true}) tpl_afterAppletSelector: TemplateRef<void>;
    @ContentChild('mainContentReplacement', {static:true}) tpl_mainContentReplacement: TemplateRef<void>;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private sessionStorage: SessionStorageService,
		private configService: CoreConfigService,
		private appSettings: AppSettingService,
		private userStorage: UserStorageService,
		private userContext: UserContextService,
		private subscriptionManager: SubscriptionManager,
		private uploadPhotoHelper: UploadPhotoHelper,
		private appStateService: AppStateService,
		private appSwitcher: AppSwitcherService,
		private principal: Principal,
		private titleService: Title,
		private dictService: DataDictService,
		private httpClient: HttpClient,
		private route: Router,
		private resourceService: UaaResourceService
	) {
		this.dictService.getItems("MNS_MESSAGE_KIND").subscribe(items => {
			this.messageKind = items;
		});
		this.navShowType = this.configService.navShowType;
	}

	ngOnInit() {
		this.init();
	}
	
	ngOnDestroy(){
		this.subscriptionManager.unsubscribe(this);
		clearInterval(this.timeId);
	}

	private init(){
		// ---------------------------------------------------------------------------
		this.footerText = this.appSettings.copyrightInfo;
		this.photoBaseUrl = this.appSettings.photoBaseUrl;
		this.defaultWinTitle = this.titleService.getTitle();
		this.hiddenAppletTitle = this.configService.hiddenAppletTitle;
		this.hiddenOfficeTitle = this.configService.hiddenOfficeTitle;
		this.hiddenNoticeIcon = this.configService.hiddenNoticeIcon;
		this.userCenterApp = this.configService.userCenterApplication;

		// ---------------------------------------------------------------------------
		// 监听路由变化
		this.subscriptionManager.register(this, this.router.events
			.pipe(filter(event => event instanceof NavigationEnd||event instanceof NavigationStart))
			.subscribe((event)=> { this.checkRouterChange(event); })
		);
		this.checkRouterChange();
		// ---------------------------------------------------------------------------
		// 监听布局变化
		this.sessionStorage.store("mainLayoutCollapsed", false);
		this.subscriptionManager.register(this, this.sessionStorage.observe("mainLayoutCollapsed").subscribe(data => {
			this.layoutCollapsed = !!data;
		}));
		this.sessionStorage.store("hiddenMainLayout", false);
		this.subscriptionManager.register(this, this.sessionStorage.observe("hiddenMainLayout").subscribe(data => {
			this.hiddenMainLayout = !!data;
		}));
		// ---------------------------------------------------------------------------
		// 监听初始化状态变化
		this.subscriptionManager.register(this, this.appStateService.readyStateChange.subscribe(readyState=>{
			// console.log("MainComponent -> appStateService.readyStateChange.subscribe -> ",readyState);
			this.checkReadyState(readyState);
		}));
		// ---------------------------------------------------------------------------
		// 监听当前机构变化
		// this.subscriptionManager.register(this, this.userContext.currentOfficeChange.subscribe(office => {
		// 	// console.log("MainComponent -> userContext.currentOfficeChange.subscribe() ->", office);
		// 	this.currentOffice = office;
		// 	const routerUrl = this.router.url;
		// 	if(routerUrl.endsWith("/403")||routerUrl.endsWith("/404")) this.goAppHome();
		// }));
		// ---------------------------------------------------------------------------
		// 监听当前应用变化
		this.subscriptionManager.register(this, this.userContext.currentAppChange.subscribe(app => {
			// console.log("MainComponent -> userContext.currentAppChange.subscribe() ->", app);
			this.currentApp = app;
			this.checkRouterChange();
		}));
		// ---------------------------------------------------------------------------
		// 监听用户登录状态
		this.subscriptionManager.register(this, this.principal.authenticationStateChange.subscribe(identity => {
			this.checkRouterChange();
		}));
		this.userContext.getCurrentUser().then(() => this.checkRouterChange());
		// ---------------------------------------------------------------------------
		this.checkReadyState(this.appStateService.readyState);
	}

	private checkReadyState(readyState:ReadyState){
		this.currentOffice = this.userContext.currentOffice;
		this.currentApp = this.userContext.currentApp;
		// console.log("MainComponent.checkReadyState() -> ", readyState);
		if (readyState.state == ReadyStateFlag.READY) {
			if(this.checkForbidden()) return;
			this.mergeSetting();
			if(this.showLoadingTimer !=null) clearTimeout(this.showLoadingTimer);
			this.showLoadingTimer = setTimeout(() => {this.showLoading = false;}, 500);
		}else{
			this.loadingMessage = readyState.message;
			this.showLoading = true;
		}
	}

	private checkForbidden(){
		if(!this.userContext.isAuthenticated||!this.appStateService.isReady) return false;

		this.forbidden = this.appSwitcher.forbidden;
		// console.log("MainComponent.checkForbidden() -> ", this.forbidden, this.showLoading);
		if(this.forbidden) this.router.navigate(["/403"]);
		return this.forbidden;
	}

	private checkRouterChange(event?:any){
		if(!(event==null||event instanceof NavigationStart||event instanceof NavigationEnd)) return;
		if(!this.principal.isAuthenticated()) return;

		// // 路由切换动画变量设置
		// this.routerState = !this.routerState;
		// this.routerStateCode = this.routerState ? 'active' : 'inactive';

		// 获取路由定义的data数据
		let route = this.activatedRoute;
		while (route.firstChild) { route = route.firstChild; }
		route.data.subscribe(data=>{
			// console.log("MainComponent.checkRouterChange() -> route.data.subscribe()");
			if (!(data['mainContentFlexLayout'] == "auto"||data['mainContentFlexLayout']==null)) this.contentFlexLayout = !!data['mainContentFlexLayout'];
			if (!(data['mainFoolterHidden'] == "auto"||data['mainFoolterHidden'] == null)) this.foolterHidden = !!data['mainFoolterHidden'];
			if (!(data['hiddenMainLayout'] == "auto"||data['hiddenMainLayout'] == null)) this.hiddenMainLayout = !!data['hiddenMainLayout'];
			this.hiddenScrolling = !!data['hiddenScrolling'];
		});

		// 自动跳转首页的分析处理
		const routerUrl = this.router.url.split(/\?/)[0]||'';
		// console.log("MainComponent.checkRouterChange() -> event = ", event, this._navigationStartUrl, routerUrl);
		this.checkInRouterApp(routerUrl);

		// 对路由地址进行分析，必要情况下跳转到系统首页或应用首页
		if(event==null){
			this._navigationStartUrl = routerUrl;
			// console.log("MainComponent.checkRouterChange() -> event is null   -> ", routerUrl);
			if (this.isHomePageRouter(routerUrl)) this.goHomePage();
			else if(routerUrl.endsWith("/403")||routerUrl.endsWith("/404")||this.isAppHomeRouter(routerUrl)) this.goAppHome();
		}else if (event instanceof NavigationStart){
			this._navigationStartUrl = (<NavigationStart>event).url;
			// console.log("MainComponent.checkRouterChange() -> NavigationStart -> ", routerUrl, this._navigationStartUrl);
		}else if (event instanceof NavigationEnd){
			const navigationEnd = <NavigationEnd>event;
			// console.log("MainComponent.checkRouterChange() -> NavigationEnd   -> ", routerUrl, navigationEnd.url);
			if (this.isHomePageRouter(routerUrl)) this.goHomePage();
			else if(this.isAppHomeRouter(routerUrl)) this.goAppHome();
			else if(navigationEnd.urlAfterRedirects && navigationEnd.urlAfterRedirects.endsWith("/404")){
				this.userContext.addPage404(navigationEnd.url);
				// console.log("MainComponent.checkRouterChange() -> add 404 page    ->", routerUrl, navigationEnd.url);
				const app = this.currentApp;
				if(this.appSwitcher.isAppHomeRouterMatch(app, navigationEnd.url)){
					this.appSwitcher.setAppHomeRouter404(app);
					this.goAppHome();
				}
			}
		}
	}

	// 判断路由中的appId是否与当前应用一致，如果不一致，则将当前应用设置路由中指定的应用
	private checkInRouterApp(routerUrl){
		if(!routerUrl.startsWith("/apps/")) return;
		const inRouterAppId = Number.parseInt(routerUrl.split('/')[2]);
		if(isNaN(inRouterAppId)) return;

		// 如果应用运行文件不是当前文件，跳到其所在的运行文件
		const app = this.appSwitcher.findApp(inRouterAppId);
		let actionUrl = app&&app.action?Url.relative(app.action):null;
		
		// console.log("checkInRouterApp", actionUrl, app);

        if(!this.configService.isDevMode&&actionUrl&&!Url.isEqualPath(actionUrl, location.href)){
            let targetUrl = actionUrl.href.split('\?')[0].split("#")[0];
            if(!targetUrl.endsWith('/')) targetUrl += '/';
			location.href = targetUrl + "#/apps/"+app.id;
		}else{
			this.appSwitcher.changeCurrentApp(inRouterAppId);
			if(!this.currentApp){
				clearTimeout(this.navigateTimer);
				this.navigateTimer = setTimeout(() => {
					if(this.userContext.currentApp == null&&!isNaN(Number.parseInt(this.router.url.split('/')[2]))){
						this.router.navigate(["/apps/errors/403"]);
					}
				}, 300);
			}
		}
	}

	// 判断是否是系统的首页路由
	private isHomePageRouter(routerUrl:string):boolean{
		return routerUrl == "/home"||routerUrl == "/apps"||routerUrl == "/apps/"||routerUrl == "/apps/home";
	}

	/**
	 * 判断是否是应用的首页路由（如：/apps/123/或/apps/123）
	 */
	private isAppHomeRouter(routerUrl:string){
		if(routerUrl==null||!routerUrl.startsWith("/apps")) return false;

		const paths = routerUrl.split("/");
		return (paths.length==3||(paths.length==4&&paths[3]==""))&&!isNaN(Number.parseInt(paths[2]));
	}


	@HostListener("window:keyup", ['$event']) onKeyup(event) {
		// console.log("keyup", event);
		if (event.code == "F9") {
			this.sessionStorage.store("hiddenMainLayout", !this.sessionStorage.retrieve("hiddenMainLayout"));
		}
	}
	@Input("content-flex-layout") contentFlexLayout: boolean = false;
	@Input("footer-hidden") foolterHidden: boolean = false;
	@Input("sider-collapsed") set isCollapsed(v: boolean) {
		this._isCollapsed = v;
	}
	get isCollapsed(): boolean {
		return this._isCollapsed || this.isForceCollapsed;
	}
	get isForceCollapsed(): boolean {
		return this.forbidden || this._currentApp == null || this._navMenu==null || this._navMenu.items.length == 0 || this.hiddenSiderMenu;
	}


	get isUserAuthenticated(): boolean {
		return this.userContext.isAuthenticated;
	}

	get currentApp(): any {
		return this._currentApp;
	}
	set currentApp(v: any) {
		this._currentApp = v;
		if (this.navShowType != 'top') {
			this.navbarResourceName = (v ? v.name : null);
		} else {
			if (this.currentApp && this.currentApp.resourceType === 'APPLICATION') {
				this.baseRouteUrl = this.currentApp.action;
			}
		}
		// console.log("MainComponent -> set currentApp -> ", v, this.navbarResourceName);
		this.titleService.setTitle(
			this.currentApp ? (this.currentApp.fullDisplayName || this.currentApp.name) : this.defaultWinTitle
		);
	}

	get currentOffice(): any {
		return this._currentOffice;
	}
	set currentOffice(v: any) {
		this._currentOffice = v;
		this.mergeSetting();
	}

	getNavbarResourceName(navItem) {
		// console.log("navItem.name="+navItem.name, 'navItem.baseRouteUrl='+navItem.baseRouteUrl, navItem);
		this.baseRouteUrl = navItem.baseRouteUrl;
		this.navbarResourceName = navItem.name;
	}

	private mergeSetting() {
		let logo = null;
		let icon = null;

		// console.log("mergeSetting-> currentOffice=",this.currentOffice);
		const settings = this.appSettings.getOfficeSettings(this.currentOffice);
		if (settings != null){
			logo = settings[this.configService.settingKeys.LOGO_HEADER_FULL];
			icon = settings[this.configService.settingKeys.LOGO_HEADER_ICON];
			// console.log("this.userStorage.getCurrentOfficeLevel() =", this.userStorage.getCurrentOfficeLevel());
			if(this.currentOffice == null){
				logo = this.configService.mainPage.headerLogo||logo;
				icon = this.configService.mainPage.headerLogoIcon||icon;
			}
		}
		if(logo==null) logo = this.configService.mainPage.headerLogo;
		if(icon==null) icon = this.configService.mainPage.headerLogoIcon;

		this.footerText = this.configService.mainPage.footerText||this.footerText;
		this.logoWide = logo ? `${this.photoBaseUrl}${logo}?g=0&x=0&y=0&r=0&q=0&f=png` : this.defaultLogo;
		this.logoIcon = icon ? `${this.photoBaseUrl}${icon}?g=0&x=0&y=0&r=0&q=0&f=png` : this.logoWide;
	}
	goHomePage() {
		const homePage = this.configService.homePage;
		// console.log("goHomePage -> homePage=", homePage);
		if(homePage&&!this.userContext.isPage404(homePage)) this.router.navigate([homePage]);
		else this.goAppHome();
	}
	private goAppHome(){
		const app = this.currentApp;
		if(this.checkForbidden()||app==null) return;

		// console.log("goAppHome -> ", this.forbidden, this._navMenu);
		clearTimeout(this.navigateTimer);
		this.navigateTimer = setTimeout(()=>{
			if(!this.forbidden&&!this.appSwitcher.isAppHomeRouter404(app)){
				if(!this.appSwitcher.isAppHomeRouterMatch(app, this._navigationStartUrl))
					this.router.navigate([app.appHomeRouter]);
			}else{
				const app = this.currentApp;
				if(this.checkForbidden()||app==null) return;
		
				let appHomeRouter = this.configService.appDefaultDashboard;
				if (appHomeRouter==null||this.userContext.isPage404(appHomeRouter))
				appHomeRouter = "/apps/"+ app.id +"/dashboard";
				// console.log(this.checkForbidden(), app, this.router.url, this._navigationStartUrl, appHomeRouter);
				if(!this.appSwitcher.isAppHomeRouterMatch(appHomeRouter, this._navigationStartUrl))
					this.router.navigate([appHomeRouter], 
						{ skipLocationChange: this.isAppHomeRouter(this._navigationStartUrl) }
					);
			}
		},100);
	}

    gotoUserCenter(){
		// 加载个人中心
		this.appSwitcher.navigateToUserCenter();
    }

	onSiderMenuDataChange(navMenu: NavMenu) {
		this.userContext.putData("MainSiderMenu", navMenu);
		this._navMenu = navMenu;
		const app = this.currentApp;
		if(!app) return;

		// if(!navMenu||navMenu.items.length == 0){
		// 	// console.log(app, navMenu);
		// 	// this.router.navigate(["/apps/"+ app.id +"/dashboard"]);
		// }else{
		// 	const menuItems = navMenu?navMenu.pathFromRootByUrl(this._navigationStartUrl):[];
		// 	// 没有权限或当前页面不在功能导航树中定义的，跳回默认应用首页
		// 	if(menuItems.length == 0 
		// 		&& this._navigationStartUrl != "/apps/"+ app.id +"/dashboard"
		// 		&& !this.appSwitcher.isAppHomeRouterMatch(app, this._navigationStartUrl)
		// 	){
		// 		this.router.navigate(["/apps/"+ app.id]);
		// 	}
		// }
	}

	reloadContent(){
		this.showLoadingContent = true;
		setTimeout(() => {
			this.showLoadingContent = false;
		}, 300);
	}

	// 消息
	get messageKind() {
		return this._messageKind
	}

	set messageKind(v) {
		if (v) {
			this._messageKind = v;
			this.principal.identity().then((account) => {
				if (account && account.id) {
					if (this.principal.hasAuthority(account.authorities)) {
						this.loadData();
						this.messagePolling();
					}
				}
			})
		}
	}

	popoverVisibleChange(visible) {
		if (!visible) return;
		this.loadData();
	}
	
	loadData() {
		if(this.hiddenNoticeIcon) return;

		this.loading = true;
		this.httpClient.get('/mns/api/_my/user-messages', {
			params: {
				page: '0',
				size: '10',
				readStatus: 'false'
			},
			observe: "response",
		}).subscribe(
			(res: HttpResponse<any>) => {
				res.body.map((item) => {
					this._messageKind.map((_item) => {
						if (item.kind === _item.value) {
							if (_item.data) {
								item.logo = this.photoBaseUrl + JSON.parse(_item.data).logo
							}	
						}
					})
				})
				this.data.map((val) => {
					val.list = res.body;
				})
				this.count  = res.headers.get('x-total-count');
				this.loading = false;
			},
			(error) => {
				if (error.status == 401) {
					clearInterval(this.timeId);
				}
			}
		)
	}

	messagePolling () {
		if(this.hiddenNoticeIcon) return;
		clearInterval(this.timeId);
		this.timeId = setInterval(() => {
			this.loadData();
		}, 120000)
	}

	loadMore() {
		const app = this.currentApp;
	    const appName = this.configService.entryApplication;
		this.route.navigate(['/apps/' + app.id + '/' + appName + '/my/messages'])
	}

	select(message) {
		if (message.item.readOver) return;
		this.httpClient.post('/mns/api/_my/user-message/READ?id=' + message.item.id, null).subscribe(
			(success) => {
				message.item.readOver = true;
				this.count --;
			}
		)
	}

	clear() {
		const ids = [];
		if (this.data.length && this.data[0].list.length) {
			this.data[0].list.map((item) => {
				ids[ids.length] = item.id;
			})
		}
		this.httpClient.post('/mns/api/_my/user-message/read-all', null).subscribe(
			(success) => {
				this.loadData();
			}
		)
	}
	
}